import { InformationVideoCategory } from '@model';
import { Action } from '@ngrx/store';

export enum InformationVideosActionTypes {
    InformationVideosLoad = '[InformationVideos] Load data',
    InformationVideosLoadSuccess = '[InformationVideos] Load success',
    InformationVideosLoadFail = '[InformationVideos] Load fail'
}

export class InformationVideosLoad implements Action {
  readonly type = InformationVideosActionTypes.InformationVideosLoad;
  constructor() {}
}

export class InformationVideosLoadSuccess implements Action {
  readonly type = InformationVideosActionTypes.InformationVideosLoadSuccess;
  constructor(public payload: InformationVideoCategory[]) {}
}

export class InformationVideosLoadFail implements Action {
  readonly type = InformationVideosActionTypes.InformationVideosLoadFail;
  constructor(public payload: any) {}
}

export type InformationVideosActions =
  | InformationVideosLoad
  | InformationVideosLoadSuccess
  | InformationVideosLoadFail

